import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import {
  Box,
  Paper,
  Typography,
  TextField,
  Button,
  Stack,
  CircularProgress,
  Alert,
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { Edit as EditIcon, Save as SaveIcon, ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import RichTextEditor from '../components/RichTextEditor';

function NoticeEditPage() {
  const { id } = useParams();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get(`/notices/${id}`)
      .then((res) => {
        setTitle(res.data.title);
        setContent(res.data.content);
      })
      .catch(() => setError('공지 정보를 불러올 수 없습니다.'))
      .finally(() => setLoading(false));
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!title.trim()) {
      setError('제목을 입력해주세요.');
      return;
    }

    if (!content || content === '<p></p>' || content === '') {
      setError('내용을 입력해주세요.');
      return;
    }

    try {
      setSaving(true);
      await api.put(`/notices/${id}`, { 
        title: title.trim(), 
        content 
      });
      navigate(`/notice/${id}`);
    } catch (err) {
      setError(err?.response?.data?.message || '수정 실패');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ pt: { xs: 2, sm: 3 }, pb: 2, px: 2, maxWidth: 900, mx: 'auto' }}>
      <Paper
        sx={{
          p: 4,
          borderRadius: 3,
          boxShadow: 3,
          backgroundColor: 'background.paper',
        }}
      >
        {/* 모바일은 헤더에 페이지 제목이 표시되므로 본문 제목 숨김 */}
        <Stack direction="row" alignItems="center" spacing={1} mb={4} sx={{ display: { xs: 'none', sm: 'flex' } }}>
          <EditIcon color="primary" sx={{ fontSize: 28 }} />
          <Typography variant="h5" sx={{ fontWeight: 700 }}>
            공지사항 수정
          </Typography>
        </Stack>

        <form onSubmit={handleSubmit}>
          <Stack spacing={3}>
            <TextField
              label="제목"
              variant="outlined"
              fullWidth
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="공지사항 제목을 입력하세요"
              sx={{
                '& .MuiOutlinedInput-root': {
                  fontSize: '1.1rem',
                },
              }}
            />

            {error && (
              <Alert severity="error" onClose={() => setError('')}>
                {error}
              </Alert>
            )}

            <RichTextEditor value={content} onChange={setContent} />

            <Stack direction="row" justifyContent="flex-end" spacing={2}>
              <Button
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={() => navigate(`/notice/${id}`)}
                disabled={saving}
              >
                취소
              </Button>
              <Button
                variant="contained"
                color="primary"
                type="submit"
                startIcon={<SaveIcon />}
                disabled={saving}
              >
                {saving ? <CircularProgress size={20} color="inherit" /> : '저장'}
              </Button>
            </Stack>
          </Stack>
        </form>
      </Paper>
    </Box>
  );
}

export default NoticeEditPage;